import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  isAuthenticated: boolean;
  children: ReactNode;  
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ isAuthenticated, children }) => {
  const auth = isAuthenticated || localStorage.getItem("isAuthenticated") === "true";

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>; 
};

export default PrivateRoute;
